import {StyleSheet} from 'react-native';

import {cloudLightest, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: cloudLightest,
  },
  header: {
    paddingVertical: 20,
    backgroundColor: white,
  },
  heading: {
    marginBottom: 10,
  },
  content: {
    paddingBottom: 20,
  },
});
